import {toast} from "react-toastify";


export const successMessage=message=>{
    return false;
    toast.success(message,{
        position:"bottom-right",
        // autoClose:false,
        closeButton:true
    })
};

export const errorMessage=message=>{
    toast.error(message,{
        position:"top-right",
        closeButton:true,
        // autoClose:false,
    })
}